export { FEATURE_FLAGS, SERVER_FEATURE_FLAGS } from './constants/featureFlags'

export const EVENTS_CATEGORY = 'All'

export const DEV = process.env.ENVIRONMENT === 'development'

export enum EVENT_ACTIONS {
  USER_REGISTERED = 'User Registered',
  USER_DELETED = 'User Deleted',
  USER_MODIFIED = 'Account Modified',
  PLAN_CREATED = 'Plan Created',
  PLAN_UPGRADED = 'Plan Upgraded',
  PLAN_DOWNGRADED = 'Plan Downgraded',
  CARD_ADDED = 'Card Added',
  CARD_CHANGED = 'Card Changed',
  LANGUAGE_CHANGED = 'Language Changed',
  PROJECT_CREATED = 'Project Created',
  PROJECT_CHANGED = 'Project Changed',
  PROJECT_DELETED = 'Project Deleted',
  PAYMENT_SUCCEEDED = 'Payment Succeeded',
  PAYMENT_FAILED = 'Payment Failed',
  PROMOCODE_USED = 'Promo Code Used',
  CONTACT_SUBMITTED = 'Contact Form Submitted',
  SUPPORT_TICKET_CREATED = 'Support Ticket Created'
}

export const SCOPE_MAP = {
  offline: 'Maintain Your Session',
  openid: 'Read Your Account Id',
  'projects.delete': 'Delete Your Projects',
  'projects.read': 'Access Existing Projects',
  'projects.write': 'Create New Projects',
  'user.read': 'Read Your Account Details'
}

// Domains
export const INFURA_APP_DOMAIN = 'app.infura.io'
export const INFURA_WEBSITE_DOMAIN = 'www.infura.io'

// Internal URLs
export const INFURA_WEBSITE_URL = 'https://www.infura.io'
export const METAMASK_DOCS_URL = 'https://docs.metamask.io'
export const METAMASK_SUPPORT_URL = 'https://support.metamask.io/develop'
export const METAMASK_COMMUNITY_SITE_URL = 'https://community.metamask.io'
export const METAMASK_DOCS_DEVELOPER_URL = `${METAMASK_DOCS_URL}/developer-tools`
export const METAMASK_DOCS_FAUCET_URL = `${METAMASK_DOCS_DEVELOPER_URL}/faucet`
export const METAMASK_DOCS_DASHBOARD_URL = `${METAMASK_DOCS_DEVELOPER_URL}/dashboard`
export const DEVELOPER_DASHBOARD_DOMAIN = process.env.DEVELOPER_DASHBOARD_DOMAIN ?? 'localhost'
export const DEVELOPER_DASHBOARD_URL = process.env.DEVELOPER_DASHBOARD_DOMAIN
  ? `https://${process.env.DEVELOPER_DASHBOARD_DOMAIN}`
  : `http://localhost:${process.env.PORT}`
export const INFURA_APP_DEV_URL = 'https://dev.infuratest.io'
export const INFURA_STATUS_PAGE_URL = 'https://status.infura.io'
export const INFURA_EXTERNAL_SUPPORT = 'https://www.infura.io/contact'

export const SUPPORT_ARTICLES = {
  fraudCheckFailed:
    'https://support.infura.io/hc/en-us/articles/14246464564123-I-received-a-Suspicious-activity-detected-error'
}

// External URLs
export const DISCORD_INVITE_LINK = 'https://discord.com/invite/consensys'
export const TRACKED_GETTING_STARTED_DISCORD_LINK = 'https://discord.gg/5QdM7893Em'
export const FEATURE_PREVIEW_COOKIE = 'feature_preview'
